import Base from './base.layout';
import Main from './main.layout';

export default {
  Base,
  Main,
};
